import React, { useState } from 'react';
import { ImageEditor } from '@shared/components/ImageEditor';
import './index.scss';

const ImageEditorTestPage: React.FC = () => {
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState<string>('');
  const [savedImage, setSavedImage] = useState<string>('');
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  // Примеры изображений для тестирования
  const sampleImages = [
    'https://picsum.photos/800/600?random=1',
    'https://picsum.photos/800/600?random=2',
    'https://picsum.photos/800/600?random=3',
  ];

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploadedFile(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setCurrentImage(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSave = (dataUrl: string) => {
    setSavedImage(dataUrl);
    setIsEditorOpen(false);
    console.log('Изображение сохранено:', dataUrl);
  };

  const openEditor = (imageUrl?: string) => {
    if (imageUrl) {
      setCurrentImage(imageUrl);
    }
    setIsEditorOpen(true);
  };

  const downloadImage = () => {
    if (savedImage) {
      const link = document.createElement('a');
      link.href = savedImage;
      link.download = 'edited-image.png';
      link.click();
    }
  };

  return (
    <div className="image-editor-test-page">
      <div className="header">
        <h1>Тестовая страница ImageEditor</h1>
        <p>Тестирование компонента редактора изображений</p>
      </div>

      <div className="controls">
        <div className="control-section">
          <h3>Загрузка изображения</h3>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileUpload}
            className="file-input"
          />
          {uploadedFile && (
            <p className="file-info">
              Загружен файл: {uploadedFile.name} ({(uploadedFile.size / 1024).toFixed(1)} KB)
            </p>
          )}
        </div>

        <div className="control-section">
          <h3>Примеры изображений</h3>
          <div className="sample-images">
            {sampleImages.map((imageUrl, index) => (
              <div key={index} className="sample-image-container">
                <img
                  src={imageUrl}
                  alt={`Пример ${index + 1}`}
                  onClick={() => openEditor(imageUrl)}
                  className="sample-image"
                />
                <button
                  onClick={() => openEditor(imageUrl)}
                  className="use-image-btn"
                >
                  Использовать
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="control-section">
          <h3>Действия</h3>
          <div className="action-buttons">
            <button
              onClick={() => openEditor()}
              className="btn btn-primary"
              disabled={!currentImage}
            >
              Открыть редактор
            </button>
            <button
              onClick={() => setCurrentImage('')}
              className="btn btn-secondary"
            >
              Очистить
            </button>
          </div>
        </div>
      </div>

      {currentImage && (
        <div className="preview-section">
          <h3>Предварительный просмотр</h3>
          <div className="image-preview">
            <img src={currentImage} alt="Предварительный просмотр" />
            <button
              onClick={() => openEditor()}
              className="btn btn-primary"
            >
              Редактировать
            </button>
          </div>
        </div>
      )}

      {savedImage && (
        <div className="result-section">
          <h3>Результат редактирования</h3>
          <div className="result-image">
            <img src={savedImage} alt="Результат" />
            <div className="result-actions">
              <button onClick={downloadImage} className="btn btn-success">
                Скачать
              </button>
              <button
                onClick={() => setSavedImage('')}
                className="btn btn-secondary"
              >
                Очистить
              </button>
            </div>
          </div>
        </div>
      )}

      {isEditorOpen && (
        <div className="editor-modal">
          <div className="editor-header">
            <h2>Редактор изображений</h2>
            <button
              onClick={() => setIsEditorOpen(false)}
              className="close-btn"
            >
              ✕
            </button>
          </div>
          <div className="editor-content">
            <ImageEditor
              initialImage={currentImage}
              onSave={handleSave}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageEditorTestPage;
